import React from "react"
import "./ReviewPages.css"

interface MiniReviewProps {
    title: string
    questions: any[]
    currentQuestionIndex: number
    customClassName?: string
    onClose: () => void
    onGotoQuestion: (questionNumber) => void
    onGotoReviewPage: () => void
}

export function MiniReview(props: MiniReviewProps) {
    let {title, questions, currentQuestionIndex, onClose, onGotoReviewPage, onGotoQuestion, customClassName=""} = props
    let className = `bellringers-mini-review ${customClassName}`

    return (
        <div className={className}>
            <button className="bellringers-mini-review--close-btn" onClick={onClose}>&times;</button>
            <h2 className="bellringers-mini-review--title">{title}</h2>
            <hr className="mt-3 mb-2" />
            <div className="d-flex justify-content-center">
                <div className="small">
                    <img className="mr-2" src="/assets/images/icons/v2/ico-pin-map.svg" alt="" width="20" height="" />Current
                </div>
                <div className="small mx-3">
                    <img className="mr-2" src="/assets/images/icons/v2/ico-dotted-square.svg" alt="" width="20" height="20" />Unanswered
                </div>
                <div className="small">
                    <img className="mr-2" src="/assets/images/icons/v2/ico-bookmark-bright.svg" alt="" width="16" height="" />For Review
                </div>
            </div>
            <hr className="mt-2 mb-3" />
            <div className="jumpboard-wrapper mb-2">
                <QuestionsGrid questions={questions} currentQuestionIndex={currentQuestionIndex} onGotoQuestion={onGotoQuestion}/>
            </div>
            <button className="goto-review-btn" onClick={onGotoReviewPage}>Go to Review Page</button>
        </div>
    )
}

interface MainReviewProps {
    mainTitle: string
    title: string
    questions: any[]
    customClassName?: string
    onGotoQuestion: (questionNumber) => void
}

export function MainReviewPage(props: MainReviewProps) {
    let {title, questions, onGotoQuestion, mainTitle, customClassName=""} = props
    let className = `bellringers-main-review ${customClassName}`

    return (
        <div className={className}>
           <h1 className="bellringers-main-review--title">{mainTitle}</h1>
           <div className="bellringers-main-review-info text-center">
                <p>Bellringers Questions Review</p>
                <p>
                    You may click <b>Finish</b> when you're ready to end this test.
                </p>
           </div>

            <div className="bellringers-main-review-jumpboard">
                <div className="bellringers-main-review-jumpboard--header flex-column flex-sm-row">
                    <h2 className="bellringers-main-review-jumpboard--title mb-sm-0">{title}</h2>
                    <div className="bellringers-main-review-jumpboard--opts d-flex justify-content-sm-center ml-sm-4">
                        <div className="legend ml-sm-2" style={{ "minWidth" : "112px"}}>
                            <img className="mr-1" src="/assets/images/icons/v2/ico-dotted-square.svg" alt="" width="20" height="20" />Unanswered
                        </div>
                        <div className="legend ml-3" style={{ "minWidth" : "96px"}}>
                            <img className="mr-1" src="/assets/images/icons/v2/ico-bookmark-bright.svg" alt="" width="16" height="" />For Review
                        </div>
                    </div>
                </div>
                <hr className="jumpboard-divider" />
                <div className="jumpboard-wrapper">
                    <QuestionsGrid questions={questions} onGotoQuestion={onGotoQuestion}/>
                </div>
            </div>
        </div>
    )
}

function QuestionsGrid(props) {
    let {questions, currentQuestionIndex, onGotoQuestion} = props

    return (
        <>
            {questions.map((question, index) => {
                let btnClassName = `jumpboard-btn ${question.userSubmittedAnswer && question.userSubmittedAnswer !== "?" ? "submitted": ""}`
                let {bookmarked} = question
                let questionNumber = index + 1
                let imgUrl = `/assets/images/icons/v2/ico-bookmark-bright.svg`
                let currentQuestion = index === currentQuestionIndex

                return (
                    <div className="jumpboard-btn--wrapper">
                        <button
                        key={questionNumber}
                        onClick={() => onGotoQuestion(questionNumber)}
                        className={[
                            btnClassName,
                            currentQuestion && "is-active"
                        ]
                            .filter(Boolean)
                            .join(" ")}
                        >
                            {questionNumber}
                            <BookmarkIcon visible={bookmarked} imgUrl={imgUrl}/>
                            <LocationIcon visible={currentQuestion}/>
                        </button>
                    </div>
                )
            })}
        </>
    )
}

//--- Misc Icons ---

function BookmarkIcon(props) {
    let {visible, imgUrl} = props
    return (
        visible ? 
            <img src={imgUrl} className="bookmarked-icon" alt="bookmark"/>
            : 
            null
    )
}

function LocationIcon(props) {
    let {visible} = props
    return (
        visible ?
            <span className="current-question-icon">
                <img className="" src="/assets/images/icons/v2/ico-pin-map.svg" alt="" width="18" height="18" />
            </span>
        :
        null
    )
}

function UnansweredQuestionIcon(props) {
    return (
        <div className="unanswered-question-icon"></div>
    )
}

